import React from 'react'

import clsx from 'clsx'

import useViewport from 'hooks/useViewport'

import Attribute, { VARIANTS } from './components/Attribute'

import classes from './AttributeList.module.scss'

export const ATTRIBUTE_VARIANTS = VARIANTS

/** @type {import("./types").default} */
const AttributeList = ({ attributes = [], gridIndex = 0, gridSize = 1, className }) => {
  const { down } = useViewport()

  return (
    <>
      <ul className={clsx(classes.list, classes[`list-size-${gridSize}`], className)}>
        {attributes.map(attribute => (
          <Attribute
            key={`attribute-${attribute.label}-${gridIndex}`}
            {...attribute}
            gridSize={gridSize}
            className={clsx(classes.columnListItemText, classes.listItemText)}
          />
        ))}
      </ul>
      {down('sm') && gridIndex === 0 && gridSize > 1 ? (
        <div
          className={clsx(classes.stickyWrapper, classes.stickyWrapperTop, classes[`stickyWrapper-size-${gridSize}`])}
          data-testid="stickyWrapper"
        >
          <div className={clsx(classes.stickyList, classes.hybrid)}>
            {attributes.map(({ label, isBold }) => {
              const isLastReview = label === 'Last review'
              return (
                <div
                  className={clsx('AttributeList__StickyItem', classes.stickyListItem, {
                    [classes.stickyListItemReview]: isLastReview,
                    [classes.stickyListItemBold]: isBold,
                  })}
                  key={`attribute-sticky-${label}-${gridIndex}`}
                >
                  {label}
                </div>
              )
            })}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default AttributeList
